import { h } from "preact";
import { Link } from "react-router-dom";
import { classNames } from "../helpers.js";

import i18n from "../i18n.js";
import Icon from "./Icon.jsx";

export default function WhitepaperTeaser({
  title,
  description,
  whitepaperId,
  ...props
}) {
  return (
    <section class={classNames("whitepaper-teaser", props.class)}>
      <Icon class="whitepaper-teaser__icon">whitepaper</Icon>
      <h4 class="whitepaper-teaser__title t-subtitle1">{title}</h4>
      <p class="whitepaper-teaser__description t-body3">{description}</p>
      <Link
        class="whitepaper-teaser__button"
        href={`/app/whitepaper/${encodeURIComponent(whitepaperId)}`}
      >
        {i18n.t("actions.visit_whitepaper")}
      </Link>
    </section>
  );
}
